// extracted by mini-css-extract-plugin
export default {"color-chip":"sitemap_color-chip__+u93T"};